export const SELECT_CELL = "SELECT_CELL";
export const INSERT = "INSERT";
export const INSERT_SMALL = "INSERT_SMALL";
export const DELETE = "DELETE";
export const DRAG_CELL = "DRAG_CELL";
export const BLUR_CELL = "BLUR_CELL";

export const CLEAR_HISTORY = "CLEAR_HISTORY";

export const MOVE = "MOVE";

export const CLICK_TEXT = "CLICK_TEXT";
export const DOUBLE_CLICK_TEXT = "DOUBLE_CLICK_TEXT";

export const SIDEBAR = "SIDEBAR";
export const NEW = "NEW";
export const HIGHLIGHT_CHANGE = "HIGHLIGHT_CHANGE";
export const IMPORT = "IMPORT";

export const RESIZE = "RESIZE";
export const RESIZE_START = "RESIZE_START";
export const RESIZE_END = "RESIZE_END";

export const PAINT = "PAINT"
export const BEGIN_PAINTING = "BEGIN_PAINING"
export const END_PAINTING = "END_PAINING"
export const SEND_COORDINATE = "SEND_COORD"